<template>
  <div id="app" class="d-flex flex-column">
    <Header />
    <div id="content" class="flex-grow-1 d-flex flex-column pt-4">
      <router-view />
    </div>
    <text-area-modal/>
    <confirmation-modal/>
    <price-modal/>
    <loading
      :show="loader > 0"
      :label="Object.values(labels).join('<br />')"
      loader-class="loader"
    />
  </div>
</template>

<script>
import Header from './components/Header'
import TextAreaModal from './components/TextAreaModal'
import { mapState } from 'vuex'
import Loading from 'vue-full-loading'
import ConfirmationModal from './components/ConfirmationModal'
import PriceModal from './components/PriceModal'

export default {
  name: 'App',
  computed: {
    ...mapState({
      loader: state => state.loader,
      labels: state => state.loaderLabels
    })
  },
  components: {
    ConfirmationModal,
    Header,
    TextAreaModal,
    Loading,
    PriceModal
  }
}
</script>

<style lang="sass">
#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50
  height: 100vh
  overflow: auto

  #content
    /*overflow: hidden*/
    margin: auto
    width: 90%

html
  height: 100%

body
  min-height: 100%
  overflow: visible
  line-height: 1.2

.loader
  position: absolute
  display: inline-block
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

.md-form .form-control
  border-bottom-color: black!important

.nav-link
  color: lightcyan!important

  &.active
    color: cyan!important

.btn
  color: black!important

  &:hover
    color: white!important

.calc-rates-bridge8-select
  .form-control
    color: whitesmoke!important
    border-bottom-color: whitesmoke!important

  .md-form
    label
      color: cyan!important

    &.select-dropdown
      margin: 0!important

.navbar
  .dropdown-menu
    form
      max-width: 17rem!important

.no-margin-select
  .select-wrapper
    margin: 0!important

    .select-dropdown
      margin: 0!important

.admin-tab-entity-properties
  .admin-tab-entity-properties-body
    input
      margin: 0

    .type-select
      input
        font-size: 14px!important

.switch
  label
    input[type=checkbox]:checked+.lever:after
      background-color: cornflowerblue

a.black-link
  color: black!important

  &:hover
    color: white!important
</style>



// WEBPACK FOOTER //
// src/App.vue